/**
 * This is shape of config required for our app
 */
type ConfigType = {
  cpanelBackendUri?: string;
  ipInfoToken?: string;
  framePlatformVersion?: string;
  useGeoIpLocator?: boolean;
  documentationUrl: string;
  clustersAwsDocumentationUrl?: string;
  clustersAzureDocumentationUrl?: string;
  nccDocumentationUrl?: string;
  supportUrl?: string;
  earlyAccessDocsUrl?: string;
  beamUrl?: string;
  lts: LTSVersions;
  nutanixClustersBillingUrl?: string;
  nutanixLicensesUrl?: string;
  authCookieDomain?: string;
  clustersRackAwarenessDocsUrl?: string;
  clustersAwsConsiderationsDocsUrl?: string;
  clustersTechPreviewDocsUrl?: string;
  myNutanixUrl?: string;
  billingUrl?: string;
  segmentWriteKey?: string;
  mixpanelToken?: string;
  analyticsEnvironment?: string;
};

export type LTSVersions = {
  AOS: string;
};

type InjectedConfigGlobalType = { injectedConfig: ConfigType };

export const DEFAULT_VALUES: ConfigType = {
  useGeoIpLocator: true,
  documentationUrl: 'https://portal.nutanix.com/page/documents/details',
  clustersAwsDocumentationUrl:
    'https://portal.nutanix.com/page/documents/details?targetId=Nutanix-Clusters-AWS:Nutanix-Clusters-AWS',
  clustersAzureDocumentationUrl:
    'https://portal.nutanix.com/page/documents/details?targetId=Nutanix-Cloud-Clusters-Azure:Nutanix-Cloud-Clusters-Azure',
  nccDocumentationUrl:
    'https://portal.nutanix.com/page/documents/details?targetId=Nutanix-Cloud-Clusters-Tech-Note:Nutanix-Cloud-Clusters-Tech-Note',
  supportUrl: 'https://portal.nutanix.com',
  lts: {
    AOS: '6.10',
  },
  beamUrl: 'https://beam.nutanix.com/app/cg/analyze/current-spend/overview;',
  nutanixClustersBillingUrl: 'https://billing.nutanix.com/#/onboarding?service=nutanix_clusters&page=paid-plans',
  nutanixLicensesUrl: 'https://billing.nutanix.com/#/subscriptions',
  authCookieDomain: '.frame.nutanix.com',
  clustersRackAwarenessDocsUrl: 'https://portal.nutanix.com/kb/9723',
  clustersAwsConsiderationsDocsUrl: 'https://portal.nutanix.com/kb/9733',
  clustersTechPreviewDocsUrl: 'https://www.nutanix.com/support-services/product-support/faqs/',
  myNutanixUrl: 'https://my.nutanix.com/',
  billingUrl: 'https://billing.nutanix.com',
  framePlatformVersion: 'develop',
};

/**
 * Config variables can be defined as env variables
 */
const envConfig: Partial<ConfigType> = {
  cpanelBackendUri: process.env.REACT_APP_CPANEL_BACKEND_URI,
  ipInfoToken: process.env.REACT_APP_IP_INFO_TOKEN,
};

/**
 * Config can also be injected from outside in window object
 * all config variables can be placed in window.injectedConfig object
 */
const getInjectedConfig = (): ConfigType => {
  return (window as unknown as InjectedConfigGlobalType).injectedConfig?.[window.location.origin] ?? {};
};

export const getConfig = (): ConfigType => Object.assign(DEFAULT_VALUES, envConfig, getInjectedConfig());
